<template>
  <div class="modal-mask" v-if="showModal" @click.prevent="closeModal">
    <div class="modal-wrapper" @click.stop>
      <div class="modal-container">
        <div class="modal-header">
          <span class="pull-right" @click="closeModal" style="cursor: pointer">X</span>
          <slot name="header">
            <h2>Change Your Password</h2>
          </slot>
        </div>
        <div class="modal-body">
          <slot name="body">
            <label v-if="showResMessage">{{ resMessage }}</label>
            <form class="form-horizontal" role="form" @submit.prevent="changePassword">

              <div class="form-group">
                <label class="col-sm-3 control-label">Password</label>
                <div class="col-sm-9">
                  <input type="password" class="form-control" name="password" required v-model="payload.password">
                  <span class="help-block">{{ helpText }}</span>
                  <field-error :error-message="errors.password"></field-error>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">Confirm Password</label>
                <div class="col-sm-9">
                  <input type="password" class="form-control" name="password_confirmation" required v-model="payload.password_confirmation">
                  <field-error :error-message="errors.password_confirmation"></field-error>
                </div>
              </div>

              <div class="form-group">
                <div class="form-controls col-sm-12">
                  <ul class="list-inline">
                    <li class="cancel"></li>
                    <li class="step-label"></li>
                    <li class="step-submit"><button type="submit" class="btn btn-primary">Change Password</button></li>
                  </ul>
                </div>
              </div>
            </form>
          </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <a
                href="#"
                class="modal-default-button btn btn-primary"
                @click.prevent="closeModal"
            >
              Cancel
            </a>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FieldError from "../investor/FieldError";
import axios from "axios";

export default {
    name: "ChangePassword",
    components: {
      FieldError
    },
    props: [],
    data() {
      return {
        helpText: "Min. 1 uppercase, 1 lowercase, 1 digit, 8+ characters long",
        resMessage: '',
        showResMessage: false,
        showModal: true,
        payload: {
          password: '',
          password_confirmation: ''
        },
        errors: {
          password: '',
          password_confirmation: ''
        }
      }
    },
    methods: {
      changePassword() {
        this.showResMessage = false
        this.resMessage = ''
        axios.post('edit/change-password', this.payload).
        then(response => {
          if(response.data.status === 'success') {
            this.resMessage = response.data.statusMessage
            this.showResMessage = true
            this.closeModal()
          }
          this.resMessage = response.data.statusMessage
          this.showResMessage = true
          return Promise.resolve()
        }).catch(errors => {
          if(errors.response.data.errors.password !== '') {
            this.errors.password = errors.response.data.errors.password[0]
          }
          if(errors.response.data.errors.password_confirmation !== '') {
            this.errors.password_confirmation = errors.response.data.errors.password_confirmation[0]
          }
          this.timer()
          return Promise.resolve()
        })
      },
      timer() {
        setTimeout(() => {
          this.errors = {
            password: '',
            password_confirmation: '',
          }

        }, 5000)
      },
      closeModal() {
        this.showModal = !this.showModal
        this.$emit('modal-closed',this.resMessage)
      }
    }
}
</script>